import React from 'react';
import TextField from 'material-ui/TextField';

const RFRenderTextField = ({
    input,
    label,
    meta: { touched, error },
    ...custom
  }) => (
    <TextField
      label={label}
      error={touched && error?true:false}
      helperText={touched && error}
      {...input}
      {...custom}
    />
)

export default RFRenderTextField;


// WEBPACK FOOTER //
// ./src/components/RFComponents/RFRenderTextField.js